import React from 'react';
import { Box } from '@mui/material';

const LongStringView = ({ longString }) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleToggle = () => setExpanded(!expanded);
    const previewLength = 30; // Changeable between 20–30 as needed
    const isLongComment = longString?.length > previewLength;
    const visibleComment = expanded ? longString : longString?.slice(0, previewLength);

    return (
        <Box>
            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {visibleComment}
                {!expanded && isLongComment && '...'}
            </div>
            {isLongComment && (
                <Box
                    sx={{ color: 'blue', cursor: 'pointer', mt: 0.5 }}
                    onClick={handleToggle}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </Box>
            )}
        </Box>
    );
};
export default LongStringView;